// ****
export const SPACING_MICRO = "4px";
// ******
export const SPACING_EXTRA_SMALL = "6px";
// ********
export const SPACING_SMALL = "8px";
// ************
export const SPACING_MEDIUM = "12px";
// ************************
export const SPACING_LARGE = "24px";

export enum Spacing {
  Micro = "4px",
  ExtraSmall = "6px",
  Small = "8px",
  Medium = "12px",
  MediumLarge = "16px",
  Large = "24px",
  ExtraLarge = "36px",
  Jumbo = "48px",
}
